import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import App from './App';
import { KAMSATHI_THEME } from './constants/theme';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider theme={{ token: KAMSATHI_THEME.antdToken }}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
